import axios from 'axios';
import baseUrl from '../config/baseURL';
import { getAuthToken } from '../services/auth';

// Fetch all images for a catalogue item
export const fetchCatalogueItemImages = async (
  organization_id: string | undefined,
  catalogue_id: string | undefined,
  item_id: string | undefined,
) => {
  const token = await getAuthToken();
  try {
    if (token.success && token.data) {
      const headers = { Authorization: 'Bearer ' + token.data };
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/catalogue/${catalogue_id}/catalogue-items/${item_id}/images/`;
      const response = await axios.get(endpoint, { headers });

      if (response.status >= 200 && response.status < 400) {
        return { success: true, data: response.data };
      } else {
        console.error('Failed to fetch images:', response.data);
        return { success: false, data: response.data };
      }
    } else {
      return { success: false, data: 'Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error while fetching images:', error);
    return { success: false, data: error };
  }
};

// Upload a new image for a catalogue item
export const uploadCatalogueItemImage = async (
  organization_id: string | undefined,
  item_id: string | undefined,
  catalogue_id: string,
  file: File,
) => {
  const token = await getAuthToken();
  try {
    if (token.success && token.data) {
      const headers = {
        Authorization: 'Bearer ' + token.data,
        'Content-Type': 'multipart/form-data',
      };
      const formData = new FormData();
      formData.append('image', file);

      const endpoint = `${baseUrl}/core/organizations/${organization_id}/catalogue/${catalogue_id}/catalogue-items/${item_id}/images/`;
      const response = await axios.post(endpoint, formData, { headers });

      if (response.status >= 200 && response.status < 400) {
        return { success: true, data: response.data };
      } else {
        console.error('Failed to upload image:', response.data);
        return { success: false, data: response.data };
      }
    } else {
      return { success: false, data: 'Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error while uploading image:', error);
    return { success: false, data: error };
  }
};

// Delete a catalogue item image by ID
export const deleteCatalogueItemImage = async (
  organization_id: string | undefined,
  catalogue_id: string | undefined,
  item_id: string | undefined,
  image_id: string,
) => {
  const token = await getAuthToken();
  try {
    if (token.success && token.data) {
      const headers = { Authorization: 'Bearer ' + token.data };
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/catalogue/${catalogue_id}/catalogue-items/${item_id}/images/${image_id}/`;
      const response = await axios.delete(endpoint, { headers });

      if (response.status >= 200 && response.status < 400) {
        return { success: true, data: response.data };
      } else {
        console.error('Failed to delete image:', response.data);
        return { success: false, data: response.data };
      }
    } else {
      return { success: false, data: 'Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error while deleting image:', error);
    return { success: false, data: error };
  }
};

// Update a catalogue item image (optional, e.g., replace or add metadata)
export const updateCatalogueItemImage = async (
  organization_id: string | undefined,
  catalogue_id: string | undefined,
  item_id: string | undefined,
  image_id: string,
  file: File,
) => {
  const token = await getAuthToken();
  try {
    if (token.success && token.data) {
      const headers = {
        Authorization: 'Bearer ' + token.data,
        'Content-Type': 'multipart/form-data',
      };
      const formData = new FormData();
      formData.append('image', file);

      const endpoint = `${baseUrl}/core/organizations/${organization_id}/catalogue/${catalogue_id}/catalogue-items/${item_id}/images/${image_id}/`;
      const response = await axios.put(endpoint, formData, { headers });

      if (response.status >= 200 && response.status < 400) {
        return { success: true, data: response.data };
      } else {
        console.error('Failed to update image:', response.data);
        return { success: false, data: response.data };
      }
    } else {
      return { success: false, data: 'Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error while updating image:', error);
    return { success: false, data: error };
  }
};
